import { createContext, MouseEvent } from 'react'
import { Onboarding } from 'src/interfaces/onboarding'
import { defaultColumnManagerContext, IColumnManagerContext } from 'src/interfaces/columnManager'

export interface IOnboardingsTableContext extends IColumnManagerContext {
  refreshOnboardings(): void

  // edit action
  actionAnchor: null | HTMLElement
  onboardingToAction: Onboarding | null
  openOnboardingsItemAction(event: MouseEvent<HTMLButtonElement>, onboarding: Onboarding): void
  closeOnboardingsItemAction(): void
}

export const OnboardingsTableContext = createContext<IOnboardingsTableContext>({
  ...defaultColumnManagerContext,

  refreshOnboardings: () => {},

  actionAnchor: null,
  onboardingToAction: null,
  openOnboardingsItemAction: () => {},
  closeOnboardingsItemAction: () => {},
})
